module.exports = __webpack_public_path__ + "img/border.88613be4.png";